"use client";

import useSWR from "swr";

interface Schema {
  id: string;
  name: string;
  slug: string;
  [key: string]: unknown;
}

const EMPTY: Schema[] = [];

export function useSchemas() {
  const { data, error, isLoading, mutate } = useSWR<{ schemas: Schema[] }>(
    "/api/schemas?activated=true",
    { revalidateOnFocus: false }
  );

  return {
    schemas: data?.schemas ?? EMPTY,
    isLoading,
    error,
    mutate,
  };
}
